import { useEffect, useState } from "react";
import { _EmployeeContract, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean"
import { BasicPage } from "../../../theme/Component/BasicPage"
import { BasicTable, MASK_DATE } from "../../../theme/Component/BasicTable"
import usePaginator from "../../../theme/Component/usePaginator";
import { toast } from "react-toastify";
import { _ConfigAdmin } from "../../../../core/services/dataBean/EntityCatalogVdos";

export const ConsultEmployeesInCharge = () => {

    const { instance, setBean, bean, lista, setLista } = useDataBean(_EmployeeContract);
    const config = useDataBean(_ConfigAdmin);
    const [idlnArea, setIDlnArea] = useState<number>(null);
    const paginador = usePaginator();

    useEffect(() => {
        config.instance.getFunctionalAreaByEmployee(_single.getAccountID(), null).then(
            (resp) => {

                config.setLista(resp)
                if (resp.length === 1) {
                    const data = resp[0].DataBeanProperties;
                    getAccounst(data.IDLnFunctionalID)
                }
            }
        ).catch(
            err => {
                console.log(err);
                toast.error("Algo salio mal")
            }
        )
    }, []);

    useEffect(() => {
        if (config.bean?.IDLnFunctionalID) {
            getAccounst(config.bean?.IDLnFunctionalID);
        }
    }, [config.bean])

    const getAccounst = (IDLnFunctionalID: number) => {
        instance.getEmployeeContracts(_single.getCurrenYear(), _single.getCurrentMonth(), null, null, IDLnFunctionalID, null, null, 2, null, null, paginador.page, 15).then(
            (resp) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    resp.List.forEach(element => {
                        const dataUser = element.DataBeanProperties;
                        dataUser.EntityName = `${dataUser.Name1 ?? ""} ${dataUser.Name2 ?? ""} ${dataUser.Surname1 ?? ""} ${dataUser.Surname2 ?? ""}`
                    });

                    setLista(resp.List)
                }
            }
        ).catch(
            err => { toast.error(err) }
        )
    }


    const head = [
        { title: 'NIT', property: 'Nit', visible: true },
        { title: 'Personal', property: 'EntityName', visible: true },
        { title: 'Telefono', property: 'Tel', visible: true },
        { title: 'Correo', property: 'eMail', visible: true },
        { title: 'Nivel Jerárquico', property: 'EntailmentName', visible: true },
    ]

    useEffect(()=>{
        if(idlnArea){
            getAccounst(idlnArea)
        }
    },[idlnArea])

    return (
        <BasicPage titulo={`Empleados en el Area `}>
            <div className="row">
                {config.lista.length > 1 &&
                    <div className="col-md-6">
                        <label>Area</label>
                        <select value={idlnArea} className="form-control" onChange={(e) => {
                            const value = e.target.value ? Number(e.target.value) : null;
                        }}>
                            <option value="">...</option>
                            {config.lista.map((areas)=>{
                                const area = areas.DataBeanProperties;
                                return(
                                    <option key={area.IDLnFunctionalID} value={area.IDLnFunctionalID} >{area.IDLnFunctionalID}</option>
                                )
                            })}
                        </select>
                    </div>
                }
                <div className="col-md-12">
                    <BasicTable
                        head={head} body={lista}
                        rowSet={setBean}
                        pageTop={paginador.page}
                        next={paginador.next}
                        back={paginador.back}
                        records={paginador}
                    />
                </div>
            </div>
        </BasicPage>
    )
}